import { GAME_CONFIG } from '../../../../constants/gameCharacters';
import { CharacterCell } from './CharacterCell';
import { ScorePopup } from './ScorePopup';
import { gameBoardStyle, gameCellStyle } from './styles';
import type { ActiveCharacter, ScorePopup as ScorePopupType } from './types';

interface MoleGameBoardProps {
  activeCharacters: ActiveCharacter[];
  clickedSharkIds: Set<string>;
  scorePopups: ScorePopupType[];
  onCharacterClick: (
    characterId: string,
    characterScore: number,
    position: number,
    isShark: boolean,
  ) => void;
}

export const MoleGameBoard = ({
  activeCharacters,
  clickedSharkIds,
  scorePopups,
  onCharacterClick,
}: MoleGameBoardProps) => {
  return (
    <div css={gameBoardStyle}>
      {Array.from({ length: GAME_CONFIG.GRID_SIZE }).map((_, index) => {
        const activeChar = activeCharacters.find((char) => char.position === index);
        const isShark = activeChar?.character.isShark === true;
        const isClickedShark = activeChar ? clickedSharkIds.has(activeChar.id) : false;
        const popup = scorePopups.find((p) => p.position === index);

        return (
          <div key={index} css={gameCellStyle()}>
            {activeChar && (
              <CharacterCell
                activeCharacter={activeChar}
                isShark={isShark}
                isClickedShark={isClickedShark}
                onCharacterClick={onCharacterClick}
              />
            )}

            {popup && <ScorePopup score={popup.score} isShark={popup.isShark} />}
          </div>
        );
      })}
    </div>
  );
};
